import { useState } from 'react';

import Button from '../../../components/shared/Button';

import { DOCUMENTATION_TYPE_OPTIONS } from '../../../constants';
import { formatDateWithPoints } from '../../../utils';
import { usePermission } from '../../../hooks/usePermission';
import { PermissionsEnum } from '../../../types';
import { useTranslation } from 'react-i18next';

const EMPTY_PROP_TEXT = '/';

const DocumentModalContent = ({
  document,
  onOpenFile,
  showType = false,
}: {
  showType?: boolean;
  document: any;
  onOpenFile: (
    e: React.MouseEvent<HTMLButtonElement>,
    id: number,
    type: string,
    status: number
  ) => Promise<void>;
}) => {
  const { t } = useTranslation();
  const OPEN_FILE_BUTTON_TEXT = {
    idle: t('files.open_file'),
    loading: t('global.opening'),
  };
  /* Permissions */
  const canViewFile = usePermission([PermissionsEnum.DocumentFile]);
  const isFileChecked = document?.status === 1;
  const [openBtnTxt, setOpenBtnTxt] = useState(OPEN_FILE_BUTTON_TEXT.idle);

  const documentLabel = DOCUMENTATION_TYPE_OPTIONS.find(
    (option) => option.id === document.type
  )?.label;

  const handleClick = async (e: React.MouseEvent<HTMLButtonElement>) => {
    if (!canViewFile) return;
    setOpenBtnTxt(OPEN_FILE_BUTTON_TEXT.loading);
    onOpenFile(e, document.id, document.type, isFileChecked ? 1 : 0).finally(
      () => {
        setOpenBtnTxt(OPEN_FILE_BUTTON_TEXT.idle);
      }
    );
  };

  const className = 'h3 font-normal flex flex-col gap-1 ';
  return (
    <>
      <ul className="space-y-3">
        <li className={className}>
          <b>{t('global.title')}</b> {document?.title || EMPTY_PROP_TEXT}
        </li>
        <li className={className}>
          <b>{t('global.description')}</b> {document.details || EMPTY_PROP_TEXT}
        </li>
        {showType && (
          <li className={className}>
            <b>{t('documents.document_type')}</b>{' '}
            {documentLabel || EMPTY_PROP_TEXT}
          </li>
        )}
        <li className={className}>
          <b>{t('global.created_by')}</b>{' '}
          {document.user_created?.firstName +
            ' ' +
            document.user_created?.lastName || EMPTY_PROP_TEXT}
        </li>
        <li className={className}>
          <b>{t('fraud_cases.fraud_entry_date')}</b>{' '}
          {formatDateWithPoints(document.date_created.date) || EMPTY_PROP_TEXT}
        </li>

        <li className={className}>
          <b>
            {document.regions.length <= 1
              ? t('regions.region')
              : t('regions.regions')}
          </b>
          <div className="flex flex-wrap gap-2">
            {document.regions.length === 0 ? (
              <p>{EMPTY_PROP_TEXT}</p>
            ) : (
              document.regions.map((region: any, i: number) => (
                <p
                  key={i}
                  className="bg-secondary-100 w-fit py-1 px-2 rounded-lg"
                >
                  {region.name}
                </p>
              ))
            )}
          </div>
        </li>
      </ul>
      {canViewFile && isFileChecked && (
        <div className="mt-8">
          <Button className="min-w-[200px]" onClick={handleClick}>
            {openBtnTxt}
          </Button>
        </div>
      )}
    </>
  );
};

export default DocumentModalContent;
